"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "runnerPickerOptions", {
    enumerable: true,
    get: function() {
        return runnerPickerOptions;
    }
});
function runnerPickerOptions(nodeArg, npmCmd, taskArgs) {
    return {
        npmScript: {
            script: require.resolve("./runners/NpmScriptRunner.js"),
            options: {
                nodeArg,
                taskArgs,
                npmCmd
            }
        },
        worker: {
            script: require.resolve("./runners/WorkerRunner.js"),
            options: {
                taskArgs
            }
        },
        noop: {
            script: require.resolve("./runners/NoOpRunner.js"),
            options: {}
        }
    };
}
